export const fadeinTop = {
  hidden: { y: 10, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
    },
  },
  present: {
    y: 0,
    opacity: 1,
  },
  exit: {
    y: 10,
    opacity: 0,
    transition: {
      duration: 1,
    },
  },
};

export const pageTransitions = {
  hidden: { y: '50vh', opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: 'easeInOut' },
  },
  exit: {
    y: '50vh',
    opacity: 0,
    transition: { duration: 0.5, ease: 'easeInOut' },
  },
};

export const fadeinslow = {
  hidden: { opacity: 0, y: 0 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 2.5, ease: 'easeInOut' },
  },
};

export const fadeinfast = {
  hidden: { opacity: 0, y: 0 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1, ease: 'easeInOut' },
  },
};

export const contactFormAnimations = {
  hidden: { opacity: 0, y: '30%', x: '25%', scale: 0.5 },
  visible: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: { duration: 0.3, ease: 'easeInOut' },
  },
  exit: {
    opacity: 0,
    y: '30%',
    x: '25%',
    scale: 0.5,
    transition: { duration: 0.1, ease: 'easeInOut' },
  },
};
